import React, { Component } from 'react'
import propTypes from 'prop-types'
import { prefix } from 'helpers/component'
import BaseEditor from './baseEditor'
import Button from 'components/button'
import { CompanyListField } from 'components/formField'

require('./inlineEditor.scss')
const getClassName = prefix('inlineEditor-companyEditor-')

class CompanyEditor extends Component {
  state = {
    value: this.props.value,
  }

  UNSAFE_componentWillReceiveProps (nextProps) {
    if (!this.props.open && nextProps.open) {
      this.setState({ value: nextProps.value })
    }
  }

  change = (value, meta) => {
    this.setState({ value: meta })
  }

  commit = () => {
    this.props.onCommit(this.state.value)
  }

  cancel = () => {
    this.props.onCancel()
  }

  render () {
    const { open, anchor, label, width, commitLabel, cancelLabel, commitButtonWidth, cancelButtonWidth,...otherProps } = this.props
    const { value } = this.state

    const height = 48
    let editorWidth = width
    editorWidth += commitButtonWidth
    editorWidth += cancelButtonWidth
    editorWidth += 12

    return (
      <BaseEditor open={open} anchor={anchor} {...otherProps} height={height} width={editorWidth} onClose={this.cancel} onFocus={() => {}}>
        <div style={{width, display: 'inline-block'}}>
          <CompanyListField
              label={label}
              showLabel={false}
              placeholder={label}
              value={value}
              ref={e => { this.input = e }}
              autoFocus={true}
              onChange={this.change} />
        </div>
        <div className={getClassName('buttons')}>
          <Button label={cancelLabel} flat width={cancelButtonWidth} onClick={this.cancel}/>
          <Button label={commitLabel} primary width={commitButtonWidth} onClick={this.commit} />
        </div>
      </BaseEditor>
    )
  }
}

CompanyEditor.propTypes = {
  value: propTypes.shape({
    value: propTypes.number,
    label: propTypes.string,
  }),
  open: propTypes.bool.isRequired,
  anchor: propTypes.object,
  label: propTypes.string,
  width: propTypes.number,
  commitLabel: propTypes.string,
  cancelLabel: propTypes.string,
  commitButtonWidth: propTypes.number,
  cancelButtonWidth: propTypes.number,
  onCommit: propTypes.func.isRequired,  // as propTypes.value
  onCancel: propTypes.func.isRequired,
}

CompanyEditor.defaultProps = {
  width: 300,
  commitLabel: 'Update',
  cancelLabel: 'Cancel',
  commitButtonWidth: 90,
  cancelButtonWidth: 90,
}

export default CompanyEditor
